// Apply CountUp animations when block is visible in viewport
// Uses CountUp.js from library


let callback = (entries) => {
    entries.forEach(entry => {
        // when the target is visible in viewport set up the animation options
        if (entry.intersectionRatio > 0) {
            var options = {
                decimalPlaces: entry.target.dataset.decimalPlaces,
                prefix: entry.target.dataset.prefix,
                suffix: entry.target.dataset.suffix,
                separator: entry.target.dataset.separator,
                decimal: entry.target.dataset.decimal
            };

            // If the endval is a valid number run the CountUp animation
            if(!isNaN(parseFloat(entry.target.dataset.endval)) && isFinite(entry.target.dataset.endval)){
                var countUp = new CountUp(entry.target.id, entry.target.dataset.endval, options);
                countUp.start();
            }
            // Unobserve the target to prevent animation happening again
            observer.unobserve(entry.target);
        }
    });
};


// set up the IntersetionObserver
let options = {
    threshold: 0.5
}
let observer = new IntersectionObserver(callback, options);

// Get all countup blocks on page
let targets = document.querySelectorAll('.countup-number');
// Call the observer when a countup-number block is added to viewport
targets.forEach(target => observer.observe(target));
